<script setup lang="ts">
import type { Icons } from '@/components/base/BaseIcon.vue'

export type TabKey = {
  value: string
  name: string
  icon?: Icons
  disabled?: boolean
}

const props = defineProps<{
  modelValue: string
  tabs: TabKey[]
  hideTabs?: boolean
  isFullWidth?: boolean
  disableRouter?: boolean
}>()

const router = useRouter()
const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void
}>()

const onTabChange = (value: string) => {
  emit('update:modelValue', value)

  if (!props.disableRouter) {
    router.push({
      query: { activeTab: value }
    })
  }
}

const slots = useSlots()
const hasSlots = computed(() => Object.keys(slots).length > 0)
</script>

<template>
  <Tabs :model-value="modelValue" @update:model-value="onTabChange">
    <TabsList
      v-if="!hideTabs"
      variant="underline"
      :class="[hasSlots ? 'mb-6' : '', isFullWidth ? 'mx-6 sm:mx-12' : '']"
    >
      <TabsTrigger v-for="tab in tabs" :key="tab.value" variant="underline" :value="tab.value" :disabled="tab.disabled">
        <BaseIcon
          v-if="tab?.icon"
          :name="tab.icon"
          class="inline-flex size-4 shrink-0 items-center justify-center [&>svg]:size-4"
        />
        <span>{{ tab.name }}</span>
      </TabsTrigger>
    </TabsList>
    <template v-if="hasSlots">
      <TabsContent v-for="tab in tabs" :key="tab.value" :value="tab.value">
        <slot :name="tab.value" />
      </TabsContent>
    </template>
  </Tabs>
</template>
